module.exports = __webpack_public_path__ + "static/rainforest.d366ff1d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/schools/rainforest.jpeg
// module id = 134
// module chunks = 16271044753813 82267189633957